class BESSAppProjectDocsAPI extends BESSAppAPIServiceBase {

    constructor(parent) {
        super(parent, 'docs/');
    }

    updateFloorplanItem(floorplanId, isCompleted, isNotApplicable, comment, onSuccess) {
        this._post('update-floorplan-item',
            {
                data: {
                    'floorplan_id': floorplanId,
                    'shown_on_on_floorplans': isCompleted,
                    'is_not_applicable': isNotApplicable,
                    'comment': comment,
                },
                onResult: onSuccess,
            });
    }

    updateSupportingDocumentItem(docId, docType, docName, onSuccess) {
        this._post('update-supporting-doc-item',
            {
                data: {
                    'supporting_doc_id': docId,
                    'doc_type': docType,
                    'doc_name': docName,
                },
                onResult: onSuccess,
            });
    }

    uploadSupportingDocument(docId, file, docName, onSuccess) {
        this._post('upload-supporting-document',
            {
                file: file,
                data: {
                    'supporting_doc_id': docId,
                    'doc_name': docName,
                },
                onResult: onSuccess,
            });
    }

    changeSupportingDocument(docId, documentId, onSuccess) {
        this._post('change-supporting-document', {
            data: {
                'supporting_doc_id': docId,
                'document_id': documentId,
            },
            onResult: onSuccess,
        });
    }

    unlinkSupportingDocument(docId, deleteDoc, onSuccess) {
        this._post('unlink-supporting-document', {
            data: {
                'supporting_doc_id': docId,
                'delete_doc': deleteDoc,
            },
            onResult: onSuccess,
        });
    }

    updateSupportingDocumentComment(docId, comment, onSuccess) {
        this._post('update-supporting-doc-comment', {
            data: {
                'supporting_doc_id': docId,
                'comment': comment,
            },
            onResult: onSuccess,

        })
    }

    updateSupportingDocumentNotApplicable(docId, isNotApplicable, onSuccess) {
        this._post('update-supporting-doc-na', {
            data: {
                'supporting_doc_id': docId,
                'is_not_applicable': isNotApplicable,
            },
            onResult: onSuccess,
        })
    }

    renameDocument(docId, newName, onSuccess) {
        this._post('rename-document', {
            data: {
                'doc_id': docId,
                'document_name': newName,
            },
            onResult: onSuccess,

        });
    }

    removeDocument(docId, onSuccess) {
        this._post('remove-document', {
            data: {
                'doc_id': docId,
            },
            onResult: onSuccess
        });
    }
}
